import { FormField, FormInput } from "./FormField.jsx";

export function AccountModalStepContact({ form, set }) {
  return (
    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 20, marginBottom: 24 }}>
      <FormField label="Name" half>
        <FormInput value={form.contactName} onChange={(v) => set("contactName", v)} placeholder="Full name" />
      </FormField>
      <FormField label="Role" half>
        <FormInput value={form.contactRole} onChange={(v) => set("contactRole", v)} placeholder="e.g. Fleet Manager" />
      </FormField>
      <FormField label="Email" half>
        <FormInput value={form.contactEmail} onChange={(v) => set("contactEmail", v)} placeholder="name@company.com" type="email" />
      </FormField>
      <FormField label="Phone" half>
        <FormInput value={form.contactPhone} onChange={(v) => set("contactPhone", v)} placeholder="+91 ..." />
      </FormField>
    </div>
  );
}
